import GuidesMenu from './GuidesMenu';
import SelfhelpMenu from './SelfhelpMenu';
import AboutMenu from './AboutMenu';

const Menus = ({ menu, menuData, aboutMenuData, serviceMenuData, toolsMenuData }) => {
  switch (menu) {
    case 'Guides':
      return <GuidesMenu data={menuData} />;
    case 'Self help':
      return <SelfhelpMenu data={toolsMenuData} />;
    case 'About':
      return <AboutMenu data={aboutMenuData} />;
    case 'Services':
        return <AboutMenu data={serviceMenuData} />;

    default:
      return null;
  }
};

export default Menus;
